<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let show = false;
	export let editingCategoryId = null;
	export let categoryForm = { name: '', image: '', description: '' };
	export let isSavingCategory = false;

	function handleClose() {
		dispatch('close');
	}

	function handleSave() {
		dispatch('save');
	}

	function handleImageUpload(e) {
		dispatch('imageUpload', e);
	}

	function handleRemoveImage() {
		dispatch('removeImage');
	}
</script>

{#if show}
	<div class="modal-overlay" on:click={handleClose}>
		<div class="modal-box" on:click|stopPropagation>
			<div class="modal-header">
				<div class="modal-title-group">
					<span class="modal-badge-icon"><Icon name="tag" size={16} color="#FF6A00" /></span>
					<h3>{editingCategoryId ? "Editar Categoria" : "Nova Categoria"}</h3>
				</div>
				<button type="button" class="close-btn" on:click={handleClose} aria-label="Fechar">
					<Icon name="x" size={16} />
				</button>
			</div>

			<div class="modal-body">
				<div class="form-row">
					<label class="field-label" for="category-name-input">Nome da Categoria *</label>
					<input 
						id="category-name-input"
						type="text" 
						class="form-input" 
						placeholder="Ex: Burgers Artesanais, Pizzas, Bebidas..." 
						bind:value={categoryForm.name} 
					/>
				</div>

				<!-- Upload de Foto da Categoria -->
				<div class="form-row">
					<span class="field-label">Foto / Banner da Categoria</span>
					<div class="photo-upload-container">
						{#if categoryForm.image}
							<div class="photo-preview-wrapper">
								<img src={categoryForm.image} alt="Capa da Categoria" class="photo-preview-img" />
								<div class="photo-preview-overlay">
									<label class="btn-overlay-change">
										Trocar Foto
										<input type="file" accept="image/*" style="display:none;" on:change={handleImageUpload} />
									</label>
									<button type="button" class="btn-overlay-remove" on:click={handleRemoveImage}>
										Remover
									</button>
								</div>
							</div>
						{:else}
							<label class="photo-drop-box">
								<input type="file" accept="image/*" style="display:none;" on:change={handleImageUpload} />
								<div class="dropzone-svg-box">
									<Icon name="utensils" size={26} color="#FF6A00" />
								</div>
								<span class="drop-label">Fazer upload de foto da categoria</span>
								<small class="drop-sub">PNG, JPG ou WEBP até 8MB</small>
							</label>
							<div class="fallback-url-row">
								<span>Ou link da imagem:</span>
								<input type="text" placeholder="https://..." bind:value={categoryForm.image} />
							</div>
						{/if}
					</div>
				</div>

				<div class="form-row">
					<label class="field-label" for="category-desc-input">Descrição para a IA e o Cardápio</label>
					<textarea 
						id="category-desc-input"
						rows="3" 
						class="form-textarea" 
						placeholder="Conte brevemente o que o cliente encontra nesta categoria..." 
						bind:value={categoryForm.description}
					></textarea>
				</div>
			</div>

			<div class="modal-footer">
				<button type="button" class="btn-cancel" on:click={handleClose} disabled={isSavingCategory}>Cancelar</button>
				<button type="button" class="btn-save" on:click={handleSave} disabled={isSavingCategory}>
					{isSavingCategory ? "Salvando..." : "Salvar Categoria"}
				</button>
			</div>
		</div>
	</div>
{/if}

<style>
	.modal-overlay {
		position: fixed;
		inset: 0;
		background: rgba(15, 23, 42, 0.5);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1100;
		padding: 20px;
	}

	.modal-box {
		width: 520px;
		max-width: 100%;
		max-height: 90vh;
		background: #FFFFFF;
		border-radius: 16px;
		box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.2);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		animation: modalPop 0.18s cubic-bezier(0.16, 1, 0.3, 1);
	}

	@keyframes modalPop {
		from { opacity: 0; transform: scale(0.96) translateY(8px); }
		to { opacity: 1; transform: scale(1) translateY(0); }
	}

	.modal-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 18px 24px;
		border-bottom: 1px solid #E2E8F0;
	}

	.modal-title-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.modal-badge-icon {
		width: 32px;
		height: 32px;
		border-radius: 8px;
		background: #FFF7ED;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal-header h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: #0F172A;
	}

	.close-btn {
		background: transparent;
		border: none;
		cursor: pointer;
		color: #94A3B8;
		padding: 4px;
		display: flex;
		align-items: center;
		border-radius: 6px;
		transition: all 0.15s ease;
	}

	.close-btn:hover {
		background: #F1F5F9;
		color: #0F172A;
	}

	.modal-body {
		padding: 20px 24px;
		display: flex;
		flex-direction: column;
		gap: 16px;
		overflow-y: auto;
	}

	.form-row {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.field-label {
		font-size: 12px;
		font-weight: 700;
		color: #334155;
	}

	.form-input, .form-textarea {
		width: 100%;
		padding: 9px 12px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 8px;
		font-size: 13px;
		color: #0F172A;
		box-sizing: border-box;
		font-family: inherit;
		transition: border-color 0.15s, box-shadow 0.15s;
	}

	.form-input:focus, .form-textarea:focus {
		outline: none;
		border-color: #FF6A00;
		box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
	}

	.photo-upload-container {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.photo-preview-wrapper {
		position: relative;
		width: 100%;
		height: 180px;
		border-radius: 10px;
		overflow: hidden;
		border: 1px solid #E2E8F0;
	}

	.photo-preview-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.photo-preview-overlay {
		position: absolute;
		bottom: 10px;
		left: 10px;
		right: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
	}

	.btn-overlay-change, .btn-overlay-remove {
		padding: 6px 12px;
		border-radius: 6px;
		font-size: 11px;
		font-weight: 700;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		border: none;
	}

	.btn-overlay-change {
		background: rgba(255, 255, 255, 0.95);
		color: #0F172A;
		backdrop-filter: blur(4px);
	}

	.btn-overlay-remove {
		background: rgba(239, 68, 68, 0.9);
		color: #FFFFFF;
		backdrop-filter: blur(4px);
	}

	.photo-drop-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 20px;
		background: #F8FAFC;
		border: 2px dashed #CBD5E1;
		border-radius: 10px;
		cursor: pointer;
		text-align: center;
		gap: 4px;
		transition: all 0.15s ease;
	}

	.photo-drop-box:hover {
		border-color: #FF6A00;
		background: #FFF7ED;
	}

	.dropzone-svg-box {
		margin-bottom: 4px;
	}

	.drop-label {
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
	}

	.drop-sub {
		font-size: 11px;
		color: #64748B;
	}

	.fallback-url-row {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 11px;
		color: #64748B;
	}

	.fallback-url-row input {
		flex: 1;
		padding: 6px 10px;
		font-size: 12px;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		color: #0F172A;
	}

	.fallback-url-row input:focus {
		outline: none;
		border-color: #FF6A00;
	}

	.modal-footer {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
		padding: 16px 24px;
		border-top: 1px solid #E2E8F0;
		background: #F8FAFC;
	}

	.btn-cancel {
		padding: 9px 16px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 8px;
		font-size: 13px;
		font-weight: 600;
		color: #475569;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-cancel:hover {
		background: #F1F5F9;
		color: #0F172A;
	}

	.btn-save {
		padding: 9px 20px;
		background: #FF6A00;
		border: 1px solid transparent;
		border-radius: 8px;
		font-size: 13px;
		font-weight: 700;
		color: #FFFFFF;
		cursor: pointer;
		box-shadow: 0 2px 4px rgba(255, 106, 0, 0.2);
		transition: all 0.15s ease;
	}

	.btn-save:hover:not(:disabled) {
		background: #E85A00;
		transform: translateY(-1px);
	}

	.btn-save:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
</style>
